import React from 'react';
import { FormattedMessage } from 'react-intl';
import { func, node, object, string } from 'prop-types';
import { Text } from '@landtrustinc/design-system';
import { ReactComponent as ChevronLeft } from '../../assets/icons/chevron-left.svg';
import { Logo, NamedLink } from '..';
import css from './InquiryFlowChrome.module.css';

const InquiryFlowChrome = ({ backLinkName, backLinkParams, onBack, backLabel, children }) => (
  <div className={css.page}>
    <div className={css.desktopHeader}>
      <div className={css.desktopHeaderInner}>
        <NamedLink name="LandingPage">
          <Logo format="desktop" />
        </NamedLink>
        <NamedLink name={backLinkName} params={backLinkParams}>
          <Text as="span" size="sm" fontWeight="semibold" color="var(--color-primary-800)">
            <FormattedMessage id="InquiryWizard.backToListing" />
          </Text>
        </NamedLink>
      </div>
    </div>

    <div className={css.root}>
      <div className={css.mobileHeader}>
        {onBack ? (
          <button
            type="button"
            className={css.backButton}
            onClick={onBack}
            aria-label={backLabel || undefined}
            data-testid="inquiry-step-back"
          >
            <ChevronLeft className={css.backIcon} />
          </button>
        ) : (
          <NamedLink className={css.backButton} name={backLinkName} params={backLinkParams}>
            <ChevronLeft className={css.backIcon} />
          </NamedLink>
        )}
        <Text
          as="span"
          className={css.mobileTitle}
          size="md"
          fontWeight="bold"
          color="var(--color-primary-800)"
          textAlign="center"
        >
          <FormattedMessage id="InquiryWizard.messageLandowner" />
        </Text>
      </div>
      {children}
    </div>
  </div>
);

InquiryFlowChrome.defaultProps = {
  backLinkParams: null,
  onBack: null,
  backLabel: null,
};

InquiryFlowChrome.propTypes = {
  backLinkName: string.isRequired,
  backLinkParams: object,
  onBack: func,
  backLabel: string,
  children: node.isRequired,
};

export default InquiryFlowChrome;
